import axios from "axios";
import { TabICVForm } from "../pages/icv/TabICV";
import { Catalogos } from "./Catalogos";

export class ICVService {

    public async consultaICV_form(form:TabICVForm) {

		// Tupo: Cubo Indicadores Calidad de la Vivienda
        const cuboIOC:string = 'CICV' ; 

        let dimsVal:string='';
        let mtrsVal:string='';
        
        Catalogos.CAT_VARIABLES.json.forEach( (item,i) => {
            if ( Object.getOwnPropertyDescriptor(form, item.Id )?.value !== '' ) {
                dimsVal+=item.Id;
                dimsVal+=',';
            }
        })
        Catalogos.CAT_CUBO_RAMAS.json.forEach( (item,i) => {
            if ( Object.getOwnPropertyDescriptor(form, item.Id )?.value !== '' ) {
                mtrsVal+=item.Id;
                mtrsVal+=',';
            }
        })
        
        if( mtrsVal === '' ) {
            throw new Error( 'Selecciona la ruta tematica.' );
        }
        if( dimsVal === '' ) {
            throw new Error( 'Selecciona de 1 a 4 variables.' );
        }

        // FIXME, e++ agregar mas validaciones.
        if( form.periodo_mes_fin === '' ) {
            throw new Error( 'Selecciona el periodo.' );
        }
        
        const data = await axios.get(
                process.env.REACT_APP_CONTEXT_PATH_REST + '/procesaFicheroRest?' +
                    'dims=dimsVal&mtrs=mtrsVal&per=perVal&mes=mesVal&zcu=zcuVal&tipo=tipoVal'
                        .replaceAll( 'dimsVal', dimsVal )
                        .replaceAll( 'mtrsVal', mtrsVal )
                        .replaceAll( 'perVal', 'pai,pmi,paf,pmf'.replaceAll( 'pai', form.periodo_anio_inicio ).replaceAll( 'pmi', form.periodo_mes_inicio ).replaceAll( 'paf' , form.periodo_anio_fin ).replaceAll( 'pmf', form.periodo_mes_fin ) )
                        .replaceAll( 'mesVal', form.rutaTematicaMes )
                        //.replaceAll( 'zcuVal', form.CRD_FORM_ZCU_1 + "," + form.CRD_FORM_ZCU_2 ) // FIXME, e++ cuando ya se tenga el catalogo ZCU
                        .replaceAll( 'tipoVal', cuboIOC )
                , {
                    responseType: 'blob',
                }
            ).then((res) => {
                return res.data;
            });

        return data;
    }

    public async consultaICV(params : String) {

        const cuboIOC:string = 'CICV' ; // Tupo: Cubo Indicadores Otorgamiento de Crédito

        let dimsVal:string='';
        let mtrsVal:string='';
        
        
        const data = await axios.get(
                process.env.REACT_APP_CONTEXT_PATH_REST + '/procesaFicheroRest?' + params ,
                {
                    responseType: 'blob',
                }
            ).then((res) => {
                return res.data;
            });

        return data;
    }
    
	
	/**
	 *	Obtiene la url del pdf de ayuda  
	 */    
    public async consultaUrlPDF(params : String) {
        
        const data = await axios.get(
                process.env.REACT_APP_CONTEXT_PATH_REST + '/procesaFicheroAyudaRest?' + params ,
                {
                    responseType: 'text',
                }
            ).then((res) => {
                return res.data;
            });

        return data;
    }
}